export default __webpack_public_path__ + "static/media/IMG-20240729-WA0008.b4238728.jpg";